/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import ModalRoot from './modal.root';

const mapStateToProps = (state) => {
  return {
    type: state.modal.type,
    props: state.modal.props
  };
};

const ModalRootContainer = connect(mapStateToProps)(ModalRoot);

export default ModalRootContainer;
